import { globalWindow } from '@emico-utils/ssr-utils'

export type GTMEvent = Record<string, unknown>

export interface DataLayer extends Array<GTMEvent> {
  push(...items: GTMEvent[]): number
}

declare global {
  interface Window {
    dataLayer: DataLayer
  }
}

const dataLayer: DataLayer = globalWindow
  ? (globalWindow.dataLayer = globalWindow.dataLayer ?? [])
  : []

export default dataLayer
